import React, { useEffect } from 'react';
import { GetSemiAuthStateStorage, GetStateStorage, IsValidSemiAuth } from 'common/storage';
import { OnLoadRegisterAgentData } from 'services/agent';
import MailProSupportV2 from 'views/Pma/MailPro/components/MailProSupportV2';

const HelpV1Wrapper = ({ children }) => {
    const [semiStorageData, setSemiStorageData] = React.useState({});
    const isSemiLogin = IsValidSemiAuth();

    useEffect(() => {
        if (isSemiLogin) {
            /**yes we have semi session */
            const semiTempStorageData = GetSemiAuthStateStorage();
            getRegisterAgentOnLoadData(semiTempStorageData.emailAddress);
        }
    }, [isSemiLogin]);

    const getRegisterAgentOnLoadData = (emailAddress) => {
        try {
            OnLoadRegisterAgentData(emailAddress)
                .then(data => {
                    if (Object.keys(data).length > 0) {
                        setSemiStorageData(data);
                    } else {
                        setSemiStorageData({});
                    }
                })
                .catch(err => {
                    setSemiStorageData({});
                });
        } catch (err) {
            setSemiStorageData({});
        }
    };

    const getLocalData = () => {
        let data = {};
        if (isSemiLogin) {
            data = semiStorageData;
        } else {
            let localStateData = GetStateStorage();
            data =
                localStateData && localStateData.userData ? localStateData.userData : {};
        }
        return data;
    };

    const agentData = getLocalData();

    return (
        <MailProSupportV2
            accessedFromAreaID={null}
            accessedFromAreaName={'-'}
            agentData={agentData}
        >
            {children}
        </MailProSupportV2>
    );
};

export default HelpV1Wrapper;